import React from 'react';
import classNames from 'classnames';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { type HeaderLink } from '../../services/get-header-links';
import { ArrowDownIcon } from '../icons/arrow-down-icon';
import Link from '../link/internal-link';
import styles from './more-categories-dropdown.scss';

type Props = {
  items: HeaderLink[];
  currentPath: string;
  onNavigation: (item: HeaderLink) => void;
};

const MoreCategoriesDropdown: React.FC<Props> = (props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <button type="button" className={styles.trigger}>
        {t('header.more-button')}
        <ArrowDownIcon style={{ width: '1em' }} />
      </button>
      <div className={styles.dropdownRoot} data-hook="blog-desktop-header-dropdown-menu-container">
        <ul
          className={classNames(
            styles.dropdownList,
            'blog-categories-dropdown-background-color',
            'blog-navigation-container-color',
          )}
        >
          {props.items.map((item) => {
            const isActive = item.path === props.currentPath;

            return (
              <li key={item.key} className={styles.dropdownItem}>
                <Link
                  to={item.path}
                  isActive={isActive}
                  addHoverClasses={false}
                  className={classNames(styles.dropdownLink, {
                    [styles.active]: isActive,
                  })}
                  onNavigation={() => props.onNavigation(item)}
                >
                  {item.text}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default MoreCategoriesDropdown;
